<script>
import Datatable from './Datatable'
import datatableEdit from '@assets/js/datatable-editor'

export default {
	components: {Datatable},
	props: {
		data : {
			type: Array,
      required: false,
      default: () => ([]),
		},
		option : {
			type: Object,
      required: false,
      default: () => ({}),
		},
		editOption : {
			type: Object,
      required: false,
      default: () => ({}),
		}
	},
	data() {
		return {
			newOption : {
				searching: false,
				paging:false,
				keys: true,
				...this.option
			}
		}
	},
	computed : {

	},
	mounted() {
	},
	methods : {
		onInit : function(table) {
			datatableEdit({
				...this.editOption,
				dataTable : table,
			});
		}
	},

}
</script>

<template>
	<Datatable :data="data" :option="newOption"
		table-add-classes='grid'
		table-remove-classes='table-sm'
		@onInit="onInit"
	>
		<template v-slot:thead>
			<slot name="thead"></slot>
		</template>
		<template v-slot:tfoot>
			<slot name="tfoot"></slot>
		</template>
	</Datatable>

</template>
